import { Auth } from 'aws-amplify'
import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js'
import axios from 'axios'

import * as Types from '../../types/auth'

import { AWS_CONFIG } from '../../config/aws'

export async function signIn(credentials: Types.UserCredentials) {
    let user: CognitoUser = await Auth.signIn(credentials.login, credentials.password)
}

export function getCurrentToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        Auth.currentSession().
            then((session: CognitoUserSession) => {
                // console.log('User: ', session)
                resolve(session.getIdToken().getJwtToken())
            })
            .catch(err => reject(err))
    })
}

export async function signOut() {
    return Auth.signOut()
}

export async function forgotPassword(userLogin: string) {
    return Auth.forgotPassword(userLogin)
}

export async function changePassword(userLoging: string, code: string, newPassword: string) {
    return Auth.forgotPasswordSubmit(userLoging, code, newPassword)
}



// WEBPACK FOOTER //
// ./src/services/auth/auth.ts